import { handleActions } from 'redux-actions';
import {
  APP_SET_HOLDING_COMPANY,
  APP_SET_ACTIVE,
  APP_NETWORK_STATE_CHANGED,
  APP_ONLINE_STATE_CHANGED,
} from './actions';

const initialState = {
  holdingCompany: null,
  isActive: true,
  isOnline: true,
  network: {},
};

export default handleActions(
  {
    [APP_SET_HOLDING_COMPANY]: (state, action) => ({
      ...state,
      holdingCompany: action.payload,
    }),

    // More info: https://github.com/react-native-community/react-native-netinfo#api
    [APP_NETWORK_STATE_CHANGED]: (state, { payload }) => {
      return {
        ...state,
        network: {
          ...payload,
        },
      };
    },
    [APP_ONLINE_STATE_CHANGED]: (state, { payload: isOnline }) => {
      return {
        ...state,
        isOnline,
      };
    },

    [APP_SET_ACTIVE]: (state, action) => ({
      ...state,
      isActive: action.payload,
    }),
  },
  initialState
);
